<script lang="ts">
import CustomModal from '@/components/CustomModal.vue'
import { useCharacterStore } from '@/stores/characterStore.ts'
import { usePerformanceStore } from '@/stores/performanceStore.ts'
import { useSpellStore } from '@/stores/spellsStore.ts'
import { useUserStore } from '@/stores/userStore.ts'
import { BButton, BForm, BFormInput, BFormTextarea, BTable } from 'bootstrap-vue-next'
import { ref, watch } from 'vue'
import { useDesignStore } from '../../../stores/designStore.ts'

import SearchForAbilityDropdown from '@/components/SearchForAbilityDropdown.vue'
import IconPicker from '@/components/IconPicker.vue'
import ActionCostDropdown from '@/components/ActionCostDropdown.vue'
import TargetDropdown from '@/components/TargetDropdown.vue'
import AreaDropdown from '@/components/AreaDropdown.vue'
import TypeDropdown from '@/components/TypeDropdown.vue'
import DurationDropdown from '@/components/DurationDropdown.vue'
import _ from 'lodash'

export default {
  props: ['currentStatBlock', 'updateTemp'],
  setup(props, context) {
    const modal = ref(false)
    const infoModal = ref(false)
    const userStore = useUserStore()
    const designStore = useDesignStore()
    const characterStore = useCharacterStore()
    const spellsStore = useSpellStore()
    const { manualPerformanceStyles } = usePerformanceStore()

    function getMedallion(group: string) {
      switch (group) {
        case 'Offensive Perks':
          return 'gi-swords-power'
        case 'Defensive Perks':
          return 'gi-heavy-helm'
        case 'Utility Perks':
          return 'gi-gear-hammer'
        case 'Supportive Perks':
          return 'gi-heart-shield'
      }
    }

    function getSortedSkills(spec) {
      return spec.skills.sort(function (a, b) {
        let aVal =
          a.skillStats.type === 'Passive'
            ? 0
            : a.skillStats.modes
              ? a.skillStats[a.skillStats.modes[0]].type === 'Passive'
                ? 0
                : 100
              : 100
        let bVal =
          b.skillStats.type === 'Passive'
            ? 0
            : b.skillStats.modes
              ? b.skillStats[b.skillStats.modes[0]].type === 'Passive'
                ? 0
                : 100
              : 100
        let ret = 0
        if (aVal > bVal) ret = 1
        else if (aVal < bVal) ret = -1

        return ret
      })
    }
    const oneToTen = [
      { value: 0, text: '0' },
      { value: 1, text: '1' },
      { value: 2, text: '2' },
      { value: 3, text: '3' },
      { value: 4, text: '4' },
      { value: 5, text: '5' },
      { value: 6, text: '6' },
      { value: 7, text: '7' },
      { value: 8, text: '8' },
      { value: 9, text: '9' },
      { value: 10, text: '10' }
    ]
    const addAbilityModal = ref(false)
    const icon = ref('gi-dna1')

    const newAbility = ref({
      name: '',
      actionCost: 'Core Action',
      area: 'Self',
      target: 'Character',
      duration: '1 Round',
      type: 'Instantaneous',
      resistance: 'N/A',
      description: '',
      groupIcon: icon,
      spellgroup: '',
      rank: 0
    })

    function addSpellAbility() {
      if (newAbility.value.name) {
        let copy = _.cloneDeep(props.currentStatBlock)

        if (copy.abilities[newAbility.value.name]) {
          alert('Ability names must be Unique')
        }

        copy.abilities[newAbility.value.name] = JSON.parse(JSON.stringify(newAbility.value))
        props.updateTemp(copy)
        addAbilityModal.value = false
      } else {
        alert('Ability Needs A Name!')
      }
    }
    function addMartialAbility() {}

    return {
      designStore,
      userStore,
      characterStore,
      newAbility,
      modal,
      addAbilityModal,
      infoModal,
      manualPerformanceStyles,
      getSortedSkills,
      props,
      oneToTen,
      addSpellAbility,
      addMartialAbility
    }
  },
  components: {
    BButton,
    CustomModal,
    SearchForAbilityDropdown,
    IconPicker,
    ActionCostDropdown,
    TargetDropdown,
    AreaDropdown,
    TypeDropdown,
    DurationDropdown,
    BFormTextarea,
    BForm,
    BFormInput
  }
}
</script>

<template>
  <div>
    <BButton
      style="border: 1px solid; align-self: end; position: relative"
      :style="{
        background: designStore.primaryTheme,
        color: designStore.primaryText,
        borderColor: designStore.secondaryTheme
      }"
      @click="() => (addAbilityModal = true)"
      >Add Ability</BButton
    >
    <CustomModal :showModal="addAbilityModal" title="Add Ability" @close="addAbilityModal = false">
      <template v-slot:body>
        <div>
          <div style="display: flex; margin-top: -1rem">
            <SearchForAbilityDropdown
              style="align-self: flex-end; margin-bottom: 1rem"
              @ability="(ability) => ((newAbility = ability), (newAbility.spellgroup = ''))"
            ></SearchForAbilityDropdown>
            <div
              style="
                display: flex;
                justify-content: center;
                flex-direction: column;
                text-align: center;
                margin: 0.5rem;
              "
            >
              Icon
              <IconPicker
                :style="{ background: designStore.inputBacking }"
                style="align-self: center; border-radius: 10px"
                :color="designStore.iconColor"
                :currentIcon="newAbility.groupIcon"
                @selectedIcon="(icon) => (newAbility.groupIcon = icon)"
                orientation="bottom"
              ></IconPicker>
            </div>
          </div>
          <BForm
            :style="{
              background: designStore.inputBacking,
              color: designStore.inputText,
              borderColor: designStore.secondaryTheme
            }"
          >
            <BFormInput
              v-model="newAbility.name"
              placeholder="name"
              class="ability-form-item"
              :style="{
                background: designStore.inputBacking,
                color: designStore.inputText,
                '--bs-secondary-color': designStore.inputText,
                borderColor: designStore.secondaryTheme
              }"
            ></BFormInput>
            <div
              class="abilityGrid"
              style="margin-top: 0rem"
              :style="{
                background: designStore.secondaryTheme,
                color: designStore.sidebarText,
                borderColor: designStore.secondaryTheme
              }"
            >
              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">
                  Action Cost:
                </div>
                <ActionCostDropdown v-model="newAbility.actionCost"></ActionCostDropdown>
              </div>

              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">
                  Target:
                </div>
                <TargetDropdown v-model="newAbility.target"></TargetDropdown>
              </div>
              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">Area:</div>
                <AreaDropdown v-model="newAbility.area"></AreaDropdown>
              </div>
              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">Type:</div>
                <TypeDropdown v-model="newAbility.type"></TypeDropdown>
              </div>
              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">
                  Duration:
                </div>
                <DurationDropdown v-model="newAbility.duration"></DurationDropdown>
              </div>
              <div
                class="ability-item"
                :style="{
                  background: designStore.sidebarBacking,
                  color: designStore.sidebarText
                }"
              >
                <div style="align-self: center; text-wrap: nowrap; padding-left: 0.5rem">
                  Resistance:
                </div>
                <BFormInput
                  v-model="newAbility.resistance"
                  placeholder="resistance"
                  :style="{
                    background: designStore.sidebarBacking,
                    borderColor: designStore.secondaryTheme,
                    color: designStore.sidebarText,
                    '--bs-secondary-color': designStore.sidebarText
                  }"
                  style="border: none; border-radius: 0"
                ></BFormInput>
              </div>
            </div>
            <BFormTextarea
              placeholder="description"
              v-model="newAbility.description"
              class="ability-form-last-item"
              :style="{
                background: designStore.inputBacking,
                color: designStore.inputText,
                borderColor: designStore.secondaryTheme,
                '--bs-secondary-color': designStore.inputText
              }"
              style="border-top: 0; min-height: 14rem"
            ></BFormTextarea>
          </BForm>
        </div>
      </template>
      <template v-slot:footer>
        <BButton
          style="border: 1px solid"
          :style="{ borderColor: designStore.secondaryTheme }"
          @click="addSpellAbility()"
          >Add Ability</BButton
        ></template
      >
    </CustomModal>
  </div>
</template>
<style></style>
